import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseEditPopUpComponent } from '../../Services/BaseEditPopUpComponent';
import { ConfigService } from "../../Services/ConfigService";
import { ChecklistTaskService } from "../../Services/Custom/ServiceChecklistTask";
import { CompanyCourseService } from '../../Services/Custom/ServiceCompanyCourse';
import { DocumentHistoryService } from '../../Services/Custom/ServiceDocumentHistory';
import { PersonService } from '../../Services/Custom/ServicePerson';

@Component({
	selector: 'ChecklistTask-edit',
	templateUrl: 'ChecklistTaskEdit.html',
	moduleId: module.id
})
export class ChecklistTaskEditComponent extends BaseEditPopUpComponent implements OnInit {
	ngOnInit(): void {
		this.myPersonService.loadAll(this.configData.AppConfig.company)
			.subscribe(people => {
				this.staff = people;
			});
	}

	constructor(
		public configData: ConfigService,
		private myPersonService: PersonService,
		private myDocumentHistoryService: DocumentHistoryService,
		private myCompanyCourseService: CompanyCourseService,
		private modal: NgbActiveModal,
		private myChecklistTaskService: ChecklistTaskService) {
		super();
		this.activeModal = modal;
		this.myItem.PersonID = this.configData.AppConfig.me;
		this.myCompanyCourseService.loadAll()
			.subscribe(col => {
				this.courses = col.filter(a => !a.IsWebinar);
				this.webinars = col.filter(a => a.IsWebinar);
			});
		this.myDocumentHistoryService.loadAll()
			.subscribe(col => {
				this.docs = col;
			});
	}

	staff: ePM.Logic.Person[] = [];
	_myItem: ePM.Logic.ChecklistTask = {} as ePM.Logic.ChecklistTask;
	get myItem(): ePM.Logic.ChecklistTask {
		return this._myItem;
	}

	set myItem(data: ePM.Logic.ChecklistTask) {
		this._myItem = data;
		if (data) {
			let choice: number = 0;
			if (data.IsDocumentHistory) {
				choice = 3;
			} else if (data.IsCourse) {
				choice = 1;
			} else if (data.IsWebinar) {
				choice = 2;
			}
			this.linkChoice = choice;
		}
	}
	courses: ePM.Logic.CompanyCourse[] = [];
	webinars: ePM.Logic.CompanyCourse[] = [];
	docs: ePM.Logic.DocumentHistory[] = [];

	_linkChoice: number = 0;
	get linkChoice(): number {
		return this._linkChoice;
	}
	set linkChoice(choice: number) {
		this._linkChoice = choice;
		switch (this._linkChoice.toString()) {
			case "0":
				this.myItem.IsExternalDocument =
					this.myItem.IsWebinar =
					this.myItem.IsDocumentHistory =
					this.myItem.IsCourse = false;
				this.myItem.CourseID = this.configData.DefaultEmptyGuid;
				this.myItem.DocumentHistoryID = this.configData.DefaultEmptyGuid;
				this.myItem.DocumentLink = "";
				break;
			case "1":
				this.myItem.IsCourse = true;
				this.myItem.IsExternalDocument = this.myItem.IsWebinar = this.myItem.IsDocumentHistory = false;
				this.myItem.DocumentHistoryID = this.configData.DefaultEmptyGuid;
				this.myItem.DocumentLink = "";
				break;
			case "2":
				this.myItem.IsWebinar = true;
				this.myItem.IsExternalDocument =this.myItem.IsCourse = this.myItem.IsDocumentHistory = false;
				this.myItem.DocumentHistoryID = this.configData.DefaultEmptyGuid;
				this.myItem.DocumentLink = "";
				break;
			case "3":
				this.myItem.IsExternalDocument =this.myItem.IsWebinar = this.myItem.IsCourse = false;
				this.myItem.IsDocumentHistory = true;
				this.myItem.CourseID = this.configData.DefaultEmptyGuid;
				this.myItem.DocumentLink = "";
				break;
			case "4":
				this.myItem.IsExternalDocument = true;
				this.myItem.IsDocumentHistory =
					this.myItem.IsWebinar =
					this.myItem.IsCourse = false;;
				this.myItem.CourseID = this.configData.DefaultEmptyGuid;
				this.myItem.DocumentHistoryID = this.configData.DefaultEmptyGuid;
				this.myItem.DocumentLink = "https://epracticemanager.com/documents/";
				break;
		}
	}
	saveItem(form: NgForm) {
		this.myChecklistTaskService.save(this.myItem)
			.subscribe((obj) => {
				this.closePopUp(obj);
			},
				(error: any) => {
					this.showValidationErrors(error, form);
				});
	}
}